import request from "@/utils/request";

export function queryLog(page, size, data) {
  return request({
    url: "/sys/sysLog/queryLog?page=" + page + "&size=" + size,
    method: "post",
    data,
  });
}

/**
 * 按需解密普通日志详情中的小程序 encrypt 或响应 data 字段。
 * 后端只根据日志主键提取密文，不接受页面自行提交的密文。
 */
export function decryptSystemLogPayload(data) {
  return request({
    url: "/sys/sysLog/decrypt",
    method: "post",
    data,
    headers: {
      "Cache-Control": "no-store",
    },
  });
}
